import { gql } from "@apollo/client";

export const getBooksCountQuery = gql`
  query GetBooksCount {
    booksCount {
      count
    }
  }
`;
